<template>
  <a-layout class="main">
    <a-layout-sider collapsedWidth="0" breakpoint="md">
      <router-link class="logo" to="/">
        <img class="logo__img" src="@/assets/logo.png" />
      </router-link>
      <template v-if="navList.length">
        <a-menu theme="dark" mode="inline">
          <a-menu-item
            v-for="item in navList"
            :class="{ 'ant-menu-item-selected active': isCurrentLink(item.name) }"
            :key="item.name"
          >
            <router-link :to="`/entity/${item.name}`">{{
              item.gui_name || item.name
            }}</router-link>
          </a-menu-item>
        </a-menu>
        <div class="button" v-if="rights.meta">
          <a-button
            @click.prevent="$refs.entityModal.open"
            type="primary"
            block
          >
            Добавить
          </a-button>
        </div>
        <entity-modal new ref="entityModal" />
      </template>
      <div v-else class="spin">
        <a-spin size="large"></a-spin>
      </div>
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="header">
        <a-dropdown :trigger="['click']">
          <span class="user">
            <a-avatar icon="user" />
            <a-icon class="user__icon" type="down" />
          </span>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="#" @click.prevent="logout">Выйти</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-layout-header>
      <a-layout-content class="content">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import EntityModal from '@/components/Controls/Entity/Modal.vue';

export default {
  components: { EntityModal },
  computed: {
    navList() {
      return Object.values(this.$store.getters.entities);
    },
  },
  methods: {
    logout() {
      this.$store.commit('setToken', '');
      this.$router.push('/auth');
    },
    isCurrentLink(name) {
      return new RegExp(`/entity/${name}/?$`).test(this.$route.path);
    },
  },
  created() {
    this.$api.getUserInfo().then((response) => {
      this.$store.commit('setEmail', response.data.email);
      this.$store.commit('setName', response.data.name);
      this.$store.commit('setUserId', response.data.id);
      this.$store.commit('setRawColumnsSettings', response.data.tables_state || '[]');
      this.$store.commit('setRights', (response.data.class && response.data.class.privileges) || '');
    })
      .then(this.$api.getEntities)
      .then((response) => {
        this.$store.commit('setEntities', response.data);
      });
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 100vh;
  overflow: visible;
}

.logo {
  display: block;
  margin: 16px;

  &__img {
    width: 100%;
    filter: invert(100%);
  }
}

.spin {
  text-align: center;
}

.header {
  background-color: #fff;
  display: flex;
}

.user {
  cursor: pointer;
  margin-left: auto;
  height: 50px;

  &__icon {
    margin-left: 5px;
  }
}

.content {
  margin: 24px 16px;
  padding: 24px;
  background-color: #fff;
}

.button {
  margin: 6px 24px 12px;
}

.ant-menu-item > a {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-menu-item.ant-menu-item-selected:not(.active) {
  background: none;

  & > a {
    color: rgba(255, 255, 255, 0.65)
  }
}
</style>

<style lang="scss">
.ant-layout {
  overflow: visible !important;
}

.ant-layout-content,
.main .ant-layout {
  overflow: visible !important;
  width: calc(100vw - 233px) !important;
}
</style>
